import Landingpage from "./components/marketing/LandingPage.vue";
import App from "./App.vue";
import Login from "./components/auth/Login.vue";
import Register from "./components/auth/Register.vue";
import Logout from "./components/auth/Logout.vue";
import Report from "./components/Report.vue";
import EditAccount from "./components/auth/EditAccount.vue";
import ChangePassword from "./components/auth/ChangePassword.vue";
import EditProfile from "./components/auth/EditProfile.vue";

const routes = [
  { path: "/", name: "home", component: Landingpage },
  {
    path: "/todo",
    name: "todo",
    component: App,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/report/:reportId",
    name: "report",
    component: Report,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  { path: "/logout", name: "logout", component: Logout },
  {
    path: "/accounts",
    name: "accounts",
    component: EditAccount,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profiles",
    name: "profiles",
    component: EditProfile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: ChangePassword,
    meta: {
      requiresAuth: true
    }
  },
  { path: '*', component: Landingpage }
];

export default routes;
